<template>
  <div id="app">  
    <headerbom></headerbom>
      <router-view />  
  </div>
</template>

<script>  
export default {
  name: "App", 
};
</script>

<style lang="less"> 
@import url("./base/commonCSS/common.less"); 
@import url("./assets/iconfont/iconfont.css");
#app {
  background: #fff;
  min-width: 100%;
  height: 100%;
} 
</style>

 